// extracted by mini-css-extract-plugin
export default {"site-layout":"layout_site-layout__iR-3W","site-layout-background":"layout_site-layout-background__KbTBR","logo-wrapper":"layout_logo-wrapper__Eg27w","logo":"layout_logo__93tve"};